<div class="w-full flex flex-col gap-[6px]">
    <span class="font-[800] text-[14px] text-[#6B7280]">{{ label }}</span>
    <nz-date-picker class="w-full bg-[#fff]" [(ngModel)]="date" (ngModelChange)="onChange($event)"></nz-date-picker>
    <span class="text-[10px] text-[#FF0000] font-[400] h-[16px]">{{ error }}</span>
</div>